
import { BoxReadingComponent } from "./reading.box";
import { CloudReadingComponent } from "./reading.cloud";
import { DemoReadingComponent } from "./reading.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class WebReading extends mixin(environment.nexus, {
  box: BoxReadingComponent,
  cloud: CloudReadingComponent,
  demo: DemoReadingComponent,
}) {
  [key: string]: any;
}
